/**
 * Company: SPHMedia
 * Description: [A button component for navigating the custom carousel]
 */

import Next from "@assets/restaurant/slider-next.svg";
import Prev from "@assets/restaurant/slider-prev.svg";
import { ReactElement } from "react";

type CustomCarouselButtonProps = {
  direction: "next" | "prev";
  variant: "enabled" | "disabled";
  onClick: () => void;
};

export default function CustomCarouselButton({
  direction,
  variant,
  onClick,
}: CustomCarouselButtonProps): ReactElement {
  const isDisabled = variant === "disabled";
  const isPrevious = direction === "prev";

  const sliderButtonStyle =
    "flex justify-center w-[36px] h-[36px] p-1.5 bg-brand-primary rounded-full disabled:opacity-30";
  const sliderImageStyle = "w-6 h-6";

  return (
    <button
      type="button"
      aria-label={direction}
      disabled={isDisabled}
      onClick={onClick}
      className={sliderButtonStyle}
    >
      <img
        src={isPrevious ? Prev : Next}
        alt={`${direction}-arrow`}
        className={sliderImageStyle}
      />
    </button>
  );
}
